import React, { Component } from 'react';
import { connect } from "react-redux";
import VehicleCell from '../Pages/Stakeholder/Vehicle/VehicleCell';

import { openPullout } from '../../Actions/stakeholderActions';
import { VCIcon, DivisionIcon } from '../Common/Buttons/TypeIcons.js';

import axios from "axios";
import moment from "moment";
import { Trans } from 'react-i18next';

//A React component will allow us to quickly iterate and change our code. It provides 
class DamagedVehicleRow extends Component {
    constructor(props) {
        super(props);

        this.openBooking=this.openBooking.bind(this);

        this.state = {
        };
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
    }

    openBooking() {
        const element = document.getElementById(this.props.datatoggle);
        if (!element) return;

        element.classList.toggle('is-open');

        this.props.dispatch(openPullout(this.props.vehicle.last_damaged_booking))
    }

    render() {
        return (
            <div className = "alert-row">
                <div className = "float-left">
                    {
                        this.props.vehicle.Photos != '' ?
                            <img className = "alert-row-image" src={'https://digitalvms.s3.ca-central-1.amazonaws.com/vehicle-images/thumbnails/thumbnail_' + this.props.vehicle.Photos} />
                        :
                            <img className = "alert-row-image" src={this.props.settings.images.vehicle_placeholder_square} />
                    }
                </div>
                <div className = "float-left">
                    <span className = "medium">{this.props.vehicle.Year} {this.props.vehicle.Make} {this.props.vehicle.Model}</span> <Trans>has been damaged</Trans>
                    <div className = "clearfix"></div>
                    <span className = "yellow-warning"><Trans>Damaged on</Trans> {this.props.vehicle.last_damaged_booking ? (this.props.vehicle.last_damaged_booking.Damage_Post == 1 ? moment(this.props.vehicle.last_damaged_booking.End_Date).format("MMM DD, YYYY") : moment(this.props.vehicle.last_damaged_booking.Start_Date).format("MMM DD, YYYY")) : "N/A" }</span>
                    <div className = "clearfix mb-8"></div>
                    {/*<a className = "link" onClick={this.openBooking}>See Details</a>*/}
                </div>
                <div style={{padding:'8px 6px'}} className = "float-left clearfix">
                    {VCIcon(this.props.vehicle.vmh, undefined, undefined, undefined, true)}
                    {DivisionIcon(this.props.vehicle.stakeholder, undefined, undefined, undefined, true)}
                </div>
                <div className = "clearfix"></div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    stakeholder: store.stakeholder,
    settings: store.settings
});

export default connect(mapStateToProps)(DamagedVehicleRow);